import { RangeInput, RangeInputProps } from "../inputs/Range";
export { FuzzyRange };

import "../../styles/fuzzy/fuzzyRange.css";

type Props = Omit<RangeInputProps, "max" | "min">;

const FuzzyRange = (props: Props) => {
  return <RangeInput {...props} className={"fuzzyRange"} max={100} min={50} />;
};
